import React, { useState } from "react";
import { IEventView } from "./type/events.types";
import { Button } from "antd";
import { Segmented } from "antd/lib";
import { AppstoreOutlined, CalendarOutlined, PlusOutlined } from "@ant-design/icons";
import EventCalendar from "./component/event-calendar/event-calendar";
import EventCard from "./component/event-card/event-card";
import events from "../../resources/event";
import EventFormModal from "./utils/event-form-modal";
import PageHeader from "../common/page-header/page-header";


const EventView: React.FC<IEventView> = (props) => {

    const [selectedView, setSelectedView] = useState('calendar-view');


    const resources = events;

    const options = [
        {
            label: (
                <div className="view-selector view-selector--calendar">
                    <CalendarOutlined className="view-selector__icon"/>
                    <div className="view-selector__text">{resources.calendarTabName}</div>
                </div>
            ),
            value: 'calendar-view',
            tooltip: {title: 'click to see calendar view', color: 'gold'},
        },
        {
            label: (

                <div className="view-selector view-selector--card">
                    <AppstoreOutlined className="view-selector__icon"/>
                    <div className="view-selector__text">{resources.cardTabName}</div>
                </div>
            ),
            value: 'card-view',
            tooltip: {title: 'click to see card view', color: 'gold'},
        }
    ];

    const resource = events;


    return (
        <div className="hrms-events">
            <PageHeader
                title={resource.heading}
                description={resource.headingDescription}
                actions={
                    <>
                        <Segmented
                            options={options}
                            onChange={(value) => setSelectedView(value)}
                            className="hrms-events__toggle-group"
                        />
                        {props.isAdmin && <Button
                            className="hrms-events__add-button"
                            onClick={props.openAddEventModal}
                            icon={<PlusOutlined className={'add-icon'}/>}
                        >
                            {resource.addEventButtonText}
                        </Button>}
                    </>
                }
              />

            <div className="hrms-events__content">
                <div style={{display: selectedView === 'calendar-view' ? 'block' : 'none'}}>
                    <EventCalendar
                        isAdmin={props.isAdmin}
                        eventData={props.eventData}
                        handleDeleteEvent={props.handleDeleteEvent}
                        openEditEventModal={props.openEditEventModal}
                        onRangeChange={props.onRangeChange}
                        activeRange={props.activeRange}
                        handleCancelEvent={props.handleCancelEvent}
                    />
                </div>

                <div style={{display: selectedView === 'card-view' ? 'block' : 'none'}}>
                    <EventCard
                        isAdmin={props.isAdmin}
                        eventData={props.eventData}
                        handleDeleteEvent={props.handleDeleteEvent}
                        openEditEventModal={props.openEditEventModal}
                        activeRange={props.activeRange}
                        onRangeChange={props.onRangeChange}
                        handleCancelEvent={props.handleCancelEvent}
                    />
                </div>
            </div>

            <EventFormModal
                upsertEvent={props.upsertEvent}
                closeEventModal={props.closeEventModal}
                event={props.modalState.defaultFormData}
                open={props.modalState.open}
                mode={props.modalState.mode}
            />
        </div>

    )
}

export default EventView
